import "./HomePage.css";
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Modal,
  ModalBody,
  Row,
} from "reactstrap";
import React, { useEffect, useState } from "react";
import CommonService from "services/CommonService";
import { IDashboardStats } from "../../models/DashboardStats.Model";
import { useNavigate } from "react-router-dom";
import { HelperConstant } from "../../helpers/HelperConstant";
import CustomLoader from "components/Common/CustomLoader";
import { CustomButton } from "components/shared/CustomButton";
import { ICurrency } from "models/Currency.Model";
import CurrencyConvertorServices from "services/CurrencyConvertor.Services";
import axios from "axios";
import { isIn } from "../../helpers/Helper";
import { isRider } from "../../helpers/TokenHelper";
import {
  useTypedDispatch,
  useTypedSelector,
} from "features/reduxhooks/ReduxHooks";
import {
  resetTile_v1,
  updateDashboardFilter,
} from "features/reducers/filterdata/DashboardFilter.Reducers";

export default function HomePage() {
  document.title = "Home Page | DOFY-Admin";

  const [isToday, setIsToday] = useState(isRider() ? false : true);
  const [showLoading, setShowLoading] = useState(true);
  const [DashboardStats, setDashboardStats] = useState<IDashboardStats>();
  const [segmented, setSegmented] = useState<"all" | "today">(
    isRider() ? "all" : "today"
  );
  const [load, setLoad] = useState<boolean>(false);
  const navigate = useNavigate();
  const [aedReport, setAedReport] = useState({ date: "", inr: 0 });
  const [updateCurrency, setUpdateCurrency] = useState<any>("");
  const [currencyAmount, setCurrencyAmount] = useState<any>("");
  const [errUpdateCurrency, setErrUpdateCurrency] = useState<any>("");
  const [isEdit, setIsEdit] = useState(false);
  const [isConfirm, setIsConfirm] = useState(false);
  const dispatch = useTypedDispatch();

  let dashboardFilterValue = useTypedSelector(
    (state) => state.DashboardFilterReducers
  );
  const today = new Date();
  const priorDate = new Date(new Date().setDate(today.getDate() - 30));
  const riderlogin: boolean = isRider() ?? false;
  const segmentValue = localStorage.getItem("routeFrom") as any;
  const cardData = [
    {
      title: "All",
      icon: "bxs-spreadsheet",
      value: DashboardStats?.All,
      routeIndex: HelperConstant.dashboardNameIndex.AllOrders,
      canShow: true,
    },
    {
      title: "Open",
      icon: "bx-link-external",
      value: DashboardStats?.Open,
      routeIndex: HelperConstant.dashboardNameIndex.OpenOrders,
      canShow: true,
    },
    {
      title: "InProgress",
      icon: "bx-cycling",
      value: DashboardStats?.Inprogress,
      routeIndex: HelperConstant.dashboardNameIndex.InProgressOrders,
      canShow: true,
    },
    {
      title: "Completed",
      icon: "bx-check-circle",
      value: DashboardStats?.Completed,
      routeIndex: HelperConstant.dashboardNameIndex.CompletedOrders,
      canShow: true,
    },
    {
      title: "Failed",
      icon: "bx-x",
      value: DashboardStats?.Failed,
      routeIndex: HelperConstant.dashboardNameIndex.FailedOrders,
      canShow: true,
    },
    {
      title: "Cancel Request",
      icon: "bx-error",
      value: DashboardStats?.CancelRequest,
      routeIndex: HelperConstant.dashboardNameIndex.CancelRequestOrders,
      canShow: true,
    },
    {
      title: "Cancelled",
      icon: "bx-x-circle",
      value: DashboardStats?.Cancelled,
      routeIndex: HelperConstant.dashboardNameIndex.CancelledOrders,
      canShow: true,
    },
    {
      title: "Pending",
      icon: "bx-walk",
      value: DashboardStats?.Pending,
      routeIndex: HelperConstant.dashboardNameIndex.PendingOrders,
      canShow: true,
    },
    {
      title: "Return",
      icon: "mdi mdi-keyboard-return",
      value: DashboardStats?.ReturnOrder,
      routeIndex: HelperConstant.dashboardNameIndex.ReturnOrders,
      canShow: true,
    },
  ];

  const reportSegment = [
    {
      segmentTile: "All",
      segmentValue: "all",
    },
    {
      segmentTile: "Today",
      segmentValue: "today",
    },
  ];

  const groupMenuList = JSON.parse(
    localStorage.getItem("GroupedMenuList") || "{}"
  );

  const ordersMenuList = groupMenuList.Orders || [];

  const updatedCardData = cardData.map((card) => {
    const menuItem = ordersMenuList.find(
      (item: any) => item.Title.toLowerCase() === card.title.toLowerCase()
    );
    return {
      ...card,
      canShow: menuItem ? menuItem.HasAccess : false,
    };
  });

  const filerParams = {
    CityName: "",
    RiderName: "",
    PromoCodeName: "",
    productName: "",
    ModalName: "",
    BrandName: "",
    CityId: null,
    RiderId: null,
    productId: null,
    BrandId: null,
    ModelId: null,
    PromoCode: "",
    FromDate: priorDate,
    ToDate: null,
  };

  const tileKeys = [
    {
      tileKey: 1,
      tileName: "All",
      field: filerParams,
    },
    {
      tileKey: 2,
      tileName: "Open",
      field: filerParams,
    },
    {
      tileKey: 3,
      tileName: "In-Progress",
      field: filerParams,
    },
    {
      tileKey: 4,
      tileName: "Completed",
      field: filerParams,
    },
    {
      tileKey: 5,
      tileName: "Failed",
      field: filerParams,
    },
    {
      tileKey: 6,
      tileName: "Cancel Request",
      field: filerParams,
    },
    {
      tileKey: 7,
      tileName: "Cancelled",
      field: filerParams,
    },
    {
      tileKey: 8,
      tileName: "Pending",
      field: filerParams,
    },
    {
      tileKey: 9,
      tileName: "Return",
      field: filerParams,
    },
  ];

  const AllTileCondtion = () => {
    setIsToday(false);
    tileKeys.forEach((x) => {
      dispatch(
        resetTile_v1({
          sectionKey: "today",
          tileKey: x.tileKey,
        })
      );
    });
  };

  useEffect(() => {
    if (riderlogin) {
      setIsToday(false);
      localStorage.setItem("routeFrom", "all");
    }else{
      localStorage.setItem("routeFrom", "today");
    }
  }, []);

  const SegmentHandler = (val: "all" | "today") => {
    if (segmented === val) return;
    setSegmented(val);
    if (val == "today") {
      setIsToday(true);
      setShowLoading(true);
      localStorage.setItem("routeFrom", val);
    } else {
      setShowLoading(true);
      localStorage.setItem("routeFrom", val);
      AllTileCondtion();
    }
    setLoad(!load);
  };
  const updateOtherFilters = (routeIndex: any, field: any, value: any) => {
    dispatch(
      updateDashboardFilter({
        sectionKey: segmentValue,
        tileKey: routeIndex,
        field: field,
        fieldValue: value,
      })
    );
  };

  const handleRoute = (routeIndex) => {
    const fromDate = isToday
      ? new Date()
      : dashboardFilterValue[segmentValue][routeIndex].FromDate || priorDate;
    const toDate = isToday
      ? new Date()
      : dashboardFilterValue[segmentValue][routeIndex].ToDate;

    dispatch(
      updateDashboardFilter({
        sectionKey: segmentValue,
        tileKey: routeIndex,
        field: "FromDate",
        fieldValue: fromDate,
      })
    );

    dispatch(
      updateDashboardFilter({
        sectionKey: segmentValue,
        tileKey: routeIndex,
        field: "ToDate",
        fieldValue: toDate,
      })
    );

    updateOtherFilters(
      routeIndex,
      "CityName",
      dashboardFilterValue[segmentValue][routeIndex].CityName
    );
    updateOtherFilters(
      routeIndex,
      "RiderName",
      dashboardFilterValue[segmentValue][routeIndex].RiderName
    );
    updateOtherFilters(
      routeIndex,
      "PromoCodeName",
      dashboardFilterValue[segmentValue][routeIndex].PromoCodeName
    );
    updateOtherFilters(
      routeIndex,
      "ProductName",
      dashboardFilterValue[segmentValue][routeIndex].ProductName
    );
    updateOtherFilters(
      routeIndex,
      "ModalName",
      dashboardFilterValue[segmentValue][routeIndex].ModalName
    );
    updateOtherFilters(
      routeIndex,
      "BrandName",
      dashboardFilterValue[segmentValue][routeIndex].BrandName
    );
    updateOtherFilters(
      routeIndex,
      "CityId",
      dashboardFilterValue[segmentValue][routeIndex].CityId
    );
    updateOtherFilters(
      routeIndex,
      "RiderId",
      dashboardFilterValue[segmentValue][routeIndex].RiderId
    );
    updateOtherFilters(
      routeIndex,
      "ProductId",
      dashboardFilterValue[segmentValue][routeIndex].ProductId
    );
    updateOtherFilters(
      routeIndex,
      "BrandId",
      dashboardFilterValue[segmentValue][routeIndex].BrandId
    );
    updateOtherFilters(
      routeIndex,
      "ModelId",
      dashboardFilterValue[segmentValue][routeIndex].ModelId
    );
  };

  const routeHandler = (title: string, routeIndex: number) => {
    localStorage.setItem("q-action", title);
    handleRoute(routeIndex);
    navigate(`/dashboard/${routeIndex}`);
  };

  const GetDashboardStats = (isToday) => {
    CommonService.getWithQueryParam(
      "sell",
      "GetDashboardStats",
      "isToday",
      isToday
    )
      .then((res) => {
        if (res.status === 200) {
          // setShowLoading(true);
          setDashboardStats(res.data);
          setShowLoading(false);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const isErr = () => {
    setIsConfirm(false);
    setErrUpdateCurrency("Enter Update Currency Value");
  };

  const AmountUpdate = () => {
    let data: ICurrency = {
      Currency1Name: "AED",
      Currency2Name: "INR",
      Amount: updateCurrency,
      Active: true,
    };

    if (updateCurrency) {
      setErrUpdateCurrency("");
      CurrencyConvertorServices.Edit(data)
        .then((res) => {
          if (res.status == 200) {
            // setIsOpen(true);
            setIsConfirm(false);
            setIsEdit(false);
            getCurrency();
          }
        })
        .catch((e) => console.log(e));
    } else {
      setErrUpdateCurrency("Enter Update Currency Value");
    }
  };

  const getCurrency = () => {
    CurrencyConvertorServices.Get()
      .then((res) => {
        if (res.status == 200) {
          setCurrencyAmount(res.data.Amount);
          setUpdateCurrency(res.data.Amount);
        }
      })
      .catch((e) => console.log(e));
  };

  const getCurrentAED = async () => {
    if (!isIn()) {
      const resp = await axios
        .get(
          "https://cdn.jsdelivr.net/gh/fawazahmed0/currency-api@1/latest/currencies/aed/inr.json"
        )
        .then((resp) => {
          setAedReport({
            date: resp.date,
            inr: resp.inr,
          });
        })
        .catch((e) => console.log(e));
    }
  };

  useEffect(() => {
    getCurrentAED();
    getCurrency();
    // localStorage.setItem("routeFrom", "today");
  }, []);

  useEffect(() => {
    GetDashboardStats(isToday);
    if (!isToday) {
      AllTileCondtion();
    }
  }, [isToday]);

  useEffect(() => {
    setLoad(load);
  }, [load]);

  useEffect(() => {
    const redirectedFromReturn = localStorage.getItem("returnRedirect");
  
    if (redirectedFromReturn === "true") {
      localStorage.removeItem("returnRedirect");
      GetDashboardStats(isToday);
    } 
  }, []);
  

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div>
            <h5
              className="d-flex mb-3 fw-semibold text-dofy dofy-admin-font-md"
              style={{ whiteSpace: "nowrap" }}
            >
              QUICK ACTIONS
            </h5>
          </div>
          <CustomLoader isOpen={showLoading} />
          {showLoading ? (
            ""
          ) : (
            <>
              <Row className="mb-3">
                {riderlogin ? null : (
                  <>
                    {!isIn() ? (
                      <>
                        <Col xl={5}>
                          <div className="bg-white rounded-3 p-2">
                            <Row>
                              <Col xl={10} lg={10} md={10} sm={8} xs={8}>
                                <span className="fw-semibold me-1 dofy-admin-font-sm">
                                  AED -
                                </span>
                                <span className="dofy-admin-font-md fw-semibold text-dofy me-2 m-0">
                                  Rs.{currencyAmount}/-
                                </span>
                                {aedReport.inr > 0 && (
                                  <div className="marquee">
                                    <p>
                                      {" "}
                                      Date : {aedReport?.date} and INR :{" "}
                                      {aedReport?.inr?.toString()?.slice(0, 5)}
                                    </p>
                                  </div>
                                )}
                              </Col>
                              <Col
                                xl={2}
                                lg={2}
                                md={2}
                                sm={4}
                                xs={4}
                                className="text-end"
                              >
                                <i
                                  className="mdi mdi-square-edit-outline font-size-20 cursor-pointer fw-semibold"
                                  onClick={() => setIsEdit(true)}
                                ></i>
                              </Col>
                            </Row>
                          </div>
                        </Col>
                        <Col
                          xl={3}
                          lg={3}
                          md={3}
                          sm={12}
                          xs={12}
                          className="my-2"
                        ></Col>
                      </>
                    ) : (
                      <Col xl={8}></Col>
                    )}
                    <Col
                      xl={4}
                      lg={4}
                      md={4}
                      sm={12}
                      xs={12}
                      className="text-center"
                    >
                      <Row className="justify-content-center">
                        <Col>
                          <div
                            style={{
                              background: "#FFFFFF",
                              borderRadius: "10px",
                              width: "100%",
                            }}
                            className="d-flex justify-content-around p-2 px-2"
                          >
                            {(reportSegment || []).map(
                              (sVal: any, idx: number) => {
                                return (
                                  <div
                                    className={`cursor-pointer text-center segment ${
                                      segmented == sVal.segmentValue
                                        ? "segment-active"
                                        : ""
                                    }`}
                                    key={idx}
                                    onClick={() => {
                                      SegmentHandler(sVal.segmentValue);
                                    }}
                                  >
                                    <p
                                      className={`mb-0 py-2 text-nowrap segment-text dofy-admin-font-sm`}
                                    >
                                      {sVal.segmentTile}
                                    </p>
                                  </div>
                                );
                              }
                            )}
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </>
                )}
              </Row>
              <Row>
                {(updatedCardData || [])
                  .filter((x) => x.canShow)
                  ?.map((val: any, key: number) => (
                    <Col md={3} key={"_col_" + key}>
                      <Card
                        className="mini-stats-wid cursor-pointer"
                        onClick={() => routeHandler(val.title, val.routeIndex)}
                      >
                        <CardBody>
                          <div className="d-flex">
                            <div className="flex-grow-1">
                              <p className="text-muted fw-semibold dofy-admin-font-sm mb-2">
                                {val.title}{" "}
                              </p>
                              {/* <Badge className="badge-soft-info me-1"> */}
                              <h3 className="m-0 text-dofy fw-bold">
                                {val.value ? val.value : 0}
                              </h3>
                              {/* </Badge> */}
                            </div>
                            <div className="avatar-sm rounded-4 bg-primary align-self-center mini-stat-icon">
                              <span className="avatar-title rounded-circle bg-primary">
                                <i
                                  className={"bx " + val.icon + " font-size-24"}
                                ></i>
                              </span>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  ))}
              </Row>
            </>
          )}
        </Container>
        <Modal isOpen={isEdit} centered>
          <ModalBody>
            <Row className="mb-1">
              <Col xl={10} lg={10} md={10} sm={8} xs={8}>
                <div className="">
                  <i className="fas fa-cash-register text-dofy me-2 font-size-15 "></i>
                  <span className="font-size-16 fw-semibold text-dofy">
                    Update Currency Value
                  </span>
                </div>
              </Col>
              {/* <Col className='' xl={2} lg={2} md={2} sm={4} xs={4}>
                                <i className='bx bx-x font-size-18 cursor-pointer float-end' onClick={() => setIsEdit(false)}></i>
                            </Col> */}
            </Row>
            <Label className="mt-3">INR for AED</Label>
            <Input
              bsSize="lg"
              value={updateCurrency}
              onChange={(e) => setUpdateCurrency(e.target.value)}
            ></Input>
            {updateCurrency == "" && (
              <p className="font-size-12 my-1 text-danger fw-semibold">
                {errUpdateCurrency}
              </p>
            )}
            <div>
              <Row className="mt-3">
                <Col
                  xl="12"
                  sizeSm="11"
                  md="12"
                  xs="12"
                  lg="12"
                  className="d-flex justify-content-end"
                >
                  <CustomButton
                    type={"reset"}
                    btnClassName={"btn-soft-secondary me-2"}
                    iconClasssName={"bx bx-x font-size-18"}
                    name={undefined}
                    onClick={() => {
                      setIsEdit(false);
                      setUpdateCurrency(currencyAmount);
                    }}
                  />
                  <CustomButton
                    type={"button"}
                    btnClassName={"btn-success"}
                    iconClasssName={""}
                    name={"Update"}
                    onClick={() => {
                      updateCurrency == "" ? isErr() : setIsConfirm(true);
                    }}
                  />
                </Col>
              </Row>
            </div>
          </ModalBody>
        </Modal>
        <Modal isOpen={isConfirm} centered>
          <ModalBody>
            <Col xl={12}>
              <div className="">
                <i className="fas fa-cash-register text-dofy me-2 font-size-15 "></i>
                <span className="font-size-16 fw-semibold text-dofy">
                  Update Confirmation
                </span>
                <p className="my-2 font-size-14">
                  Are you sure you want to update this price?
                </p>
              </div>
              <div>
                <Row className="mt-3">
                  <Col
                    xl="12"
                    sizeSm="11"
                    md="12"
                    xs="12"
                    lg="12"
                    className="d-flex justify-content-end"
                  >
                    <CustomButton
                      type={"reset"}
                      btnClassName={"btn-soft-secondary me-2"}
                      iconClasssName={"bx bx-x font-size-18"}
                      name={undefined}
                      onClick={() => {
                        setIsConfirm(false);
                      }}
                    />
                    <CustomButton
                      type={"button"}
                      btnClassName={"btn-success"}
                      iconClasssName={""}
                      name={"Update"}
                      onClick={() => AmountUpdate()}
                    />
                  </Col>
                </Row>
              </div>
            </Col>
          </ModalBody>
        </Modal>
      </div>
    </React.Fragment>
  );
}
